// export const mapGlossaryRow = data =>
//     Object.keys(data).map(glossaryID => {
//         return {
//             ID: glossaryID,
//             name: data[glossaryID].name,
//             desc: data[glossaryID].desc,
//             sourceLang: data[glossaryID].sourceLang,
//             targetLang: data[glossaryID].targetLang
//         }
//     });

// export const mapTermRow = data =>
//     Object.keys(data).map(termID => {
//         return {
//             ID: termID,
//             source: data[termID].source,
//             target: data[termID].target,
//             note: data[termID].note
//         }
//     });

// export const mapMemoryRow = data =>
//     Object.keys(data).map(memoryID => {
//         return {
//             ID: memoryID,
//             name: data[memoryID].name,
//             note: data[memoryID].note,
//             sourceLang: data[memoryID].sourceLang
//         }
//     });

// export const mapEntryRow = data =>
//     data.map(entry => {
//         return {
//             ID: entry.id,
//             source: entry.source,
//             target: entry.target,
//             targetLang: entry.target_lang
//         }
//     });

// export const mapTaskRow = data =>
//     Object.keys(data).map(taskID => {
//         return {
//             ID: taskID,
//             name: data[taskID].name,
//             sourceLang: data[taskID].sourceLang,
//             targetLang: data[taskID].targetLang,
//             translator: data[taskID].translator,
//             editor: data[taskID].editor,
//             tDue: data[taskID].tDue,
//             eDue: data[taskID].eDue,
//             eDue: data[taskID].eDue
//         }
//     });

// export const mapProjectRow = data =>
//     Object.keys(data).map(projectID => {
//         return {
//             ID: projectID,
//             name: data[projectID].name,
//             created: data[projectID].created,
//             createdBy: data[projectID].createdBy,
//             orderNumber: data[projectID].orderNumber
//         }
//     });


// export const mapProjectMemoryRow = data =>
//     Object.keys(data).map(memoryID => {
//         return {
//             ID: memoryID,
//             name: data[memoryID].name,
//             sourceLang: data[memoryID].sourceLang,
//             penalty: data[memoryID].penalty,
//             write: data[memoryID].write
//         }
//     });

// export const mapTitleMemoryRow = data =>
//     Object.keys(data).map(memoryID => {
//         return {
//             ID: memoryID,
//             name: data[memoryID].name,
//             sourceLang: data[memoryID].sourceLang,
//             penalty: data[memoryID].penalty,
//             write: data[memoryID].write
//         }
//     });

// export const mapProjectAnalysisRow = data =>
//     Object.keys(data).map(analysisID => {
//         return {
//             ID: analysisID,
//             taskID: data[analysisID].taskID,
//             createdBy: data[analysisID].createdBy,
//             created: data[analysisID].created
//         }
//     });

// export const mapAnalysisRow = data =>
//     Object.keys(data).map(rowID => {
//         return {
//             label: data[rowID]["label"],
//             segments: data[rowID]["segments"],
//             words: data[rowID]["words"],
//             characters: data[rowID]["characters"]
//         }
//     });

// export const mapUserRow = data =>
//     Object.keys(data).map(userID => {
//         return {
//             ID: userID,
//             userName: data[userID].username,
//             role: data[userID].role
//         }
//     });

// const extractIDsData = (IDsArray, obj) => {
//     let extracted = {};
//     IDsArray.forEach(ID => extracted[ID] = obj[ID]);
//     return extracted;
// }

export const extractIDsDataAsArray = (IDsArray, obj) => IDsArray.map(ID => {
    return {
        ID,
        ...obj[ID]
    }
});

export const mapData = obj => Object.keys(obj).map(ID => {
    return {
        ID,
        ...obj[ID]
    }
});